import { __experimentalDivider as Divider } from '@wordpress/components';
import { __experimentalLinkControl as LinkControl } from '@wordpress/block-editor';
import { keys, pickBy, isEqual } from 'lodash';

const {
  i18n: { __ },
  components: { TextControl, ToggleControl },
  hooks: { applyFilters },
} = wp;

const LinkUrl = ({ link, setAttributes }) => {
  const filterQuery = applyFilters('b3rg_url_input_filter_query', {
    type: 'post',
  });
  return (
    <>
      <LinkControl
        searchInputPlaceholder={__('Enter the link here…', 'b3rg')}
        value={link}
        suggestionsQuery={filterQuery}
        onChange={(selection) => {
          const updatedLinkAttributes =
            keys(
              pickBy(selection, (value, key) => !isEqual(link[key], value)),
            ) || [];
          /* Assumes it's a custom URL if only the URL has changed.
          (This is the default behavior of the link dropdown handling the selected values.) */
          const isOnlyUrlChanged = isEqual(updatedLinkAttributes, ['url']);
          setAttributes({
            link: {
              ...selection,
              title: selection.url,
              id: isOnlyUrlChanged ? null : selection?.id,
            },
          });
        }}
        settings={[]}
        onRemove={() => setAttributes({ link: {} })}
        withCreateSuggestion={false}
      ></LinkControl>
      <Divider />
      <TextControl
        label={__('Title Attribute', 'b3rg')}
        value={link.customTitle}
        onChange={(customTitle) => {
          setAttributes({
            link: {
              ...link,
              customTitle,
              title: customTitle,
            },
          });
        }}
      />
      <Divider />
      <ToggleControl
        label={__('Open in new tab', 'b3rg')}
        checked={link.opensInNewTab}
        onChange={(opensInNewTab) => {
          setAttributes({
            link: {
              ...link,
              opensInNewTab,
            },
          });
        }}
      />
    </>
  );
};

export default LinkUrl;
